import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import LoadingComp from "../components/re-usable/loading/loading";
import Router from "../routes/euro-convergence-routes";
import Footer from "../components/footer/footer";

const EuropeLayout = () => {
  return (
    <>
      <Suspense fallback={<LoadingComp />}>
        <Routes>
          {Router.map((route, index) => {
            return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
          })}
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
};

export default EuropeLayout;